import { render, staticRenderFns } from "./NovoPlanejamentoAlojamentoDialog.vue?vue&type=template&id=711d972b&scoped=true&"
import script from "./NovoPlanejamentoAlojamentoDialog.vue?vue&type=script&lang=js&"
export * from "./NovoPlanejamentoAlojamentoDialog.vue?vue&type=script&lang=js&"
import style0 from "./NovoPlanejamentoAlojamentoDialog.vue?vue&type=style&index=0&id=711d972b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711d972b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDatePicker,VDialog,VDivider,VIcon,VRow,VSpacer,VTextField})
